import {Link} from 'react-router-dom';
import {Button, Center, Stack, Text, Title} from '@mantine/core';

// FNP-826: what a signed-in user without console permissions sees. Explicit,
// rather than a redirect that reads as a broken app. The console shares its
// Cognito pool with the portal, so most people who land here are customers who
// followed a link; signing out is the one useful thing to offer them.
export const NotAuthorizedPage = () => (
    <Center mih={300}>
        <Stack align='center' gap='sm'>
            <Title order={2}>Not authorized</Title>
            <Text>You are signed in, but you are not authorized to use the admin console.</Text>
            <Button component={Link} to='/sign-out' variant='outline'>Sign out</Button>
        </Stack>
    </Center>
);
